import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import stripePromise from "../../../../components/stripePromise";
import { AddCardForm } from "../../../21_BusinessProfile/components/cards/AddCardForm";
import { LANGUAGE } from "../../../../utils/i18n/i18n";
import { OVERRIDE_APPERANCE } from "../../../../components/CheckoutForm/utils/OVERRIDE_APPERANCE";
import { OVERRIDE_FONTS } from "../../../../components/CheckoutForm/utils/OVERRIDE_FONTS";

interface Props {
  businessUserId: string;
  setupIntentId: string;
  clientSecret: string;
  onSuccess: () => Promise<void>;
}

export default function AddCardStep(props: Props) {
  return (
    <Elements
      key={`setup-${props.clientSecret}`}
      stripe={stripePromise}
      options={{
        //@ts-ignore
        locale: LANGUAGE,
        //@ts-ignore
        appearance: OVERRIDE_APPERANCE,
        fonts: OVERRIDE_FONTS,
        //@ts-ignore
        clientSecret: props.clientSecret,
        loader: "always"
      }}
    >
      <AddCardForm
        businessUserId={props.businessUserId}
        setupIntentId={props.setupIntentId}
        onSuccess={props.onSuccess}
        hideCancel={true}
        hideSubtitle={true}
      />
    </Elements>
  );
}
